module.exports = __webpack_public_path__ + "static/media/laundry-4.1ef23283.jpg";